import * as React from "react"

type CopyFn = (text: string) => Promise<boolean> // Return success

type Result = {
  copy: CopyFn
}
function useCopyToClipboard(): Result {
  const copy: CopyFn = React.useCallback(async (text: string) => {
    if (!navigator?.clipboard) {
      console.warn("Clipboard not supported")
      return false
    }

    // Try to save to clipboard then save it in the state if worked
    try {
      const typeHTML = "text/html"
      const typePlain = "text/plain"

      const blobHTML = new Blob([text], { type: typeHTML })
      const blobPlain = new Blob([text], { type: typePlain })
      const data = [
        new ClipboardItem({
          [typeHTML]: blobHTML,
          [typePlain]: blobPlain,
        }),
      ]
      await navigator.clipboard.write(data)
      return true
    } catch (error) {
      console.warn("Copy failed", error)
      return false
    }
  }, [])

  return { copy }
}

export { useCopyToClipboard }
